import { Currency } from "@redotech/money/currencies";
import {
  createCurrencyConverter,
  CurrencyConverter,
} from "@redotech/money/exchange";
import { getCurrencyExchangeRates } from "@redotech/redo-customer-portal-app/api";
import { lazy } from "@redotech/util/cache";
import { createContext, ReactNode, useMemo } from "react";

export const CurrencyExchangeContext = createContext<
  () => Promise<CurrencyConverter>
>(async () => {
  throw new Error("Not provided");
});

export const CurrencyExchangeProvider = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}) => {
  const currencyConverter = useMemo(
    () =>
      lazy(async () => {
        const response = await getCurrencyExchangeRates();
        return createCurrencyConverter(
          new Map(Object.entries(response.data) as [Currency, number][]),
        );
      }),
    [],
  );

  return (
    <CurrencyExchangeContext.Provider value={currencyConverter}>
      {children}
    </CurrencyExchangeContext.Provider>
  );
};
